import { render, staticRenderFns } from "./OfferTable.vue?vue&type=template&id=317e405a&"
import script from "./OfferTable.vue?vue&type=script&lang=js&"
export * from "./OfferTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports